import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultiorderGraphics = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 112,
	height: 171,
	viewBox: "0 0 112 171",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 10.5739,
			y: 11.9445,
			width: 77.803,
			height: 158.186,
			rx: 12.2462,
			transform: "rotate(-7.58064 10.5739 11.9445)",
			fill: "white",
			stroke: "#0058A3",
			strokeWidth: 2.58001
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.9199,
			y: 66.2988,
			width: 73.3213,
			height: 23.6884,
			transform: "rotate(-7.58064 19.9199 66.2988)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8501 75.6171C26.7679 74.9991 27.2022 74.4314 27.8202 74.3491L32.2966 73.7534C32.9146 73.6711 33.4823 74.1055 33.5646 74.7235L34.1603 79.1998C34.2426 79.8179 33.8082 80.3856 33.1902 80.4679L28.7138 81.0636C28.0958 81.1458 27.5281 80.7115 27.4458 80.0934L26.8501 75.6171Z",
			fill: "#0058A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M32.5017 75.9214L30.1474 78.9985L28.3383 77.6143L28.6813 77.166L30.0421 78.2072L32.0534 75.5784L32.5017 75.9214Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 36.0215,
			y: 67.5703,
			width: 14.6643,
			height: 15.7923,
			rx: 2.25604,
			transform: "rotate(-7.58064 36.0215 67.5703)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 53.0898,
			y: 67.5742,
			width: 31.5845,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 53.0898 67.5742)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 53.6855,
			y: 72.0449,
			width: 15.7923,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 53.6855 72.0449)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 54.2812,
			y: 76.5176,
			width: 22.5604,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 54.2812 76.5176)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.793,
			y: 42.8184,
			width: 73.3213,
			height: 23.6884,
			transform: "rotate(-7.58064 16.793 42.8184)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.7119 51.009L29.1881 50.4133C29.7289 50.3413 30.226 50.7208 30.298 51.2616L30.8937 55.7378C30.9657 56.2786 30.5852 56.7758 30.0444 56.8478L25.5683 57.4435C25.0275 57.5154 24.5312 57.1349 24.4592 56.5941L23.8635 52.1179C23.7916 51.5772 24.1712 51.081 24.7119 51.009Z",
			fill: "white",
			stroke: "#929292",
			strokeWidth: .282236
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 32.8945,
			y: 44.0879,
			width: 14.6643,
			height: 15.7923,
			rx: 2.25604,
			transform: "rotate(-7.58064 32.8945 44.0879)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 49.9648,
			y: 44.0918,
			width: 31.5845,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 49.9648 44.0918)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 50.5605,
			y: 48.5645,
			width: 15.7923,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 50.5605 48.5645)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 51.1543,
			y: 53.0371,
			width: 22.5604,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 51.1543 53.0371)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23.0449,
			y: 89.7793,
			width: 73.3213,
			height: 23.6884,
			transform: "rotate(-7.58064 23.0449 89.7793)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.9639 97.97L35.4401 97.3742C35.9808 97.3023 36.478 97.6818 36.5499 98.2225L37.1456 102.699C37.2176 103.239 36.8372 103.737 36.2964 103.809L31.8202 104.404C31.2794 104.476 30.7831 104.096 30.7112 103.555L30.1155 99.0789C30.0435 98.5381 30.4231 98.0419 30.9639 97.97Z",
			fill: "white",
			stroke: "#929292",
			strokeWidth: .282236
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 39.1465,
			y: 91.0508,
			width: 14.6643,
			height: 15.7923,
			rx: 2.25604,
			transform: "rotate(-7.58064 39.1465 91.0508)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 56.2168,
			y: 91.0547,
			width: 31.5845,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 56.2168 91.0547)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 56.8086,
			y: 95.5273,
			width: 15.7923,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 56.8086 95.5273)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 57.4043,
			y: 100,
			width: 22.5604,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 57.4043 100)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 26.1719,
			y: 113.262,
			width: 73.3213,
			height: 23.6884,
			transform: "rotate(-7.58064 26.1719 113.262)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.1001 122.58C33.0179 121.962 33.4522 121.394 34.0702 121.312L38.5466 120.716C39.1646 120.634 39.7323 121.068 39.8146 121.686L40.4103 126.163C40.4926 126.781 40.0582 127.348 39.4402 127.431L34.9638 128.026C34.3458 128.109 33.7781 127.674 33.6958 127.056L33.1001 122.58Z",
			fill: "#0058A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M38.7517 122.884L36.3974 125.961L34.5883 124.577L34.9313 124.129L36.2921 125.17L38.3034 122.541L38.7517 122.884Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42.2715,
			y: 114.533,
			width: 14.6643,
			height: 15.7923,
			rx: 2.25604,
			transform: "rotate(-7.58064 42.2715 114.533)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 59.3418,
			y: 114.535,
			width: 31.5845,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 59.3418 114.535)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 59.9355,
			y: 119.01,
			width: 15.7923,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 59.9355 119.01)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 60.5312,
			y: 123.482,
			width: 22.5604,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 60.5312 123.482)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.2949 136.742L101.975 127.07L104.654 147.196C104.9 149.049 103.599 150.751 101.746 150.997L35.7744 159.777C33.9218 160.024 32.2201 158.722 31.9735 156.869L29.2949 136.742Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.2251 146.062C36.1429 145.444 36.5772 144.877 37.1952 144.794L41.6716 144.199C42.2896 144.116 42.8573 144.551 42.9396 145.169L43.5353 149.645C43.6176 150.263 43.1832 150.831 42.5652 150.913L38.0888 151.509C37.4708 151.591 36.9031 151.157 36.8208 150.539L36.2251 146.062Z",
			fill: "#0058A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.8767 146.367L39.5224 149.444L37.7133 148.06L38.0563 147.611L39.4171 148.653L41.4284 146.024L41.8767 146.367Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 45.3945,
			y: 138.014,
			width: 14.6643,
			height: 15.7923,
			rx: 2.25604,
			transform: "rotate(-7.58064 45.3945 138.014)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 62.4648,
			y: 138.02,
			width: 31.5845,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 62.4648 138.02)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 63.0605,
			y: 142.49,
			width: 15.7923,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 63.0605 142.49)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 63.6562,
			y: 146.963,
			width: 22.5604,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-7.58064 63.6562 146.963)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_7611_61660)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 17.0938,
				y: 21.5098,
				width: 73.3213,
				height: 23.6884,
				rx: 2.25604,
				transform: "rotate(-14.5063 17.0938 21.5098)",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.0972 29.925C24.9411 29.3214 25.3038 28.7054 25.9074 28.5492L30.2792 27.4181C30.8828 27.2619 31.4988 27.6246 31.655 28.2283L32.7861 32.6001C32.9423 33.2037 32.5796 33.8196 31.9759 33.9758L27.6041 35.107C27.0005 35.2631 26.3846 34.9004 26.2284 34.2968L25.0972 29.925Z",
			fill: "#0058A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.7433 29.5447L28.7773 32.8833L26.8144 31.7274L27.1008 31.241L28.5773 32.1105L30.2569 29.2583L30.7433 29.5447Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 33.2285,
			y: 20.8301,
			width: 14.6643,
			height: 15.7923,
			rx: 2.25604,
			transform: "rotate(-14.5063 33.2285 20.8301)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 50.1758,
			y: 18.7754,
			width: 31.5845,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-14.5063 50.1758 18.7754)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 51.3066,
			y: 23.1426,
			width: 15.7923,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-14.5063 51.3066 23.1426)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 52.4355,
			y: 27.5117,
			width: 22.5604,
			height: 2.25604,
			rx: 1.12802,
			transform: "rotate(-14.5063 52.4355 27.5117)",
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_7611_61660",
			x: -.46237,
			y: -9.89951,
			width: 112.028,
			height: 76.4111,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4.51208 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 9.02415 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_7611_61660"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_7611_61660",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgMultiorderGraphics;
